export default async function (to, from, savedPosition) {
      const findEl = async (hash, x = 0) => {
        return (
          document.querySelector(hash) ||
          new Promise((resolve) => {
            if (x > 50) {
              return resolve(document.querySelector("#__nuxt"));
            }
            setTimeout(() => {
              resolve(findEl(hash, ++x || 1));
            }, 100);
          }));
      };

      // The following scroll rules only apply to lieux__{local}
      if (!to.name.includes('lieux__')) {
        return savedPosition || { x: 0, y: 0 };
      }

      // Wait for the mainArea to be loaded in the dom, so the window is of its definite size
      // Lieux has an animation, so we delay the scroll until its done
      await findEl('.mainArea');
      if (savedPosition) {
        return savedPosition;
      }

      if (to.hash) {
        let el = await findEl(to.hash);
        let iterationCount = 0;
        const scrollInterval = setInterval(() => {
          if (el.offsetTop > 0 || iterationCount >= 50) {
            clearInterval(scrollInterval);
            window.scrollTo({ top: el.offsetTop, behavior: "auto" });
          }
          iterationCount++;
        }, 50);
      }
      return { x: 0, y: 0 };
    }
